import { render, staticRenderFns } from "./Notificacao.vue?vue&type=template&id=5a6b11ed&scoped=true"
import script from "./Notificacao.vue?vue&type=script&lang=js"
export * from "./Notificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b11ed",
  null
  
)

export default component.exports